// -----------------------------------------------------------------------------------------------------
// @ USER UTILITIES
//
// -----------------------------------------------------------------------------------------------------

import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";


@Injectable({
    providedIn: 'root'
})
export class UserUtils {

    avatarBaseUrl = '/assets/profile_placeholders/';
    avatarList = ['animal-bear.png','animal-beaver.png','animal-bison.png','animal-camel.png','animal-cow.png','animal-crocodile.png','animal-deer.png','animal-dog.png','animal-donkey.png',
    'animal-elephant.png','animal-fox.png','animal-giraffe.png','animal-hare.png','animal-hedgehog.png','animal-hippopotamus.png','animal-lion.png','animal-meerkat.png',
    'animal-monkey.png','animal-moose.png','animal-mouse.png','animal-penguin.png','animal-pig.png','animal-polarbear.png','animal-rabbit.png','animal-raccoon.png',
    'animal-rhino.png','animal-seal.png','animal-sheep.png','animal-tigger.png','animal-tortoise.png','animal-walrus.png','animal-wildpig.png','animal-wolf.png'];
    
    /**
     * Constructor
     */
    constructor(
        private http: HttpClient,
    ) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    async getRandomAnimalAvatar() {
        const item = this.avatarList[Math.floor(Math.random()*this.avatarList.length)];
        const base64 = await this.convertToBase64(`${this.avatarBaseUrl}${item}`);
        return base64 as string;
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Private methods
    // -----------------------------------------------------------------------------------------------------


    private convertToBase64(file: string): Promise<string | ArrayBuffer> {
        return new Promise((resolve, reject) => {
        this.http.get(file, { responseType: 'blob' })
            .subscribe(res => {
                const reader = new FileReader();
                reader.onerror = reject;
                reader.onloadend = () => {
                    resolve(reader.result);
                };
        
                reader.readAsDataURL(res);
            });
        });
    }
}
